import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  Back,
  Divider,
  ArticleLink,
  ArticleContent,
  ArticleDescription,
  ArticleViewWrapper,
} from './styles';

import messages from '../messages';

function ArticleView({ articleUrl, helpCentreUrl, showArticleView }) {
  const [articleData, setArticleData] = useState({});
  const { title, description, url, content } = articleData;

  useEffect(() => {
    if (!articleUrl) return;
    const ARTICLE_FILE = 'index.json';
    const HELP_CENTRE_URL = `${helpCentreUrl}/json`;
    async function getArticleInformation() {
      const data = await fetch(`${HELP_CENTRE_URL}${articleUrl}${ARTICLE_FILE}`)
        .then((response) => response.json());

      setArticleData({
        url: data.url,
        title: data.title,
        content: data.content_html,
        description: data.description,
      });
    }

    getArticleInformation();
  }, [articleUrl, helpCentreUrl]);

  return (
    <Fragment>
      <Back onClick={() => showArticleView(false)}>
        <MaterialIcon id="keyboard_arrow_left" />
        {intl.formatMessage(messages.back)}
      </Back>
      <Divider />

      <ArticleViewWrapper>
        <ArticleLink href={url} target="_blank">
          {title}
          <MaterialIcon id="open_in_new" />
        </ArticleLink>
        <ArticleDescription>{description}</ArticleDescription>
        <ArticleContent dangerouslySetInnerHTML={{ __html: content }} />
      </ArticleViewWrapper>
    </Fragment>
  );
}

ArticleView.propTypes = {
  articleUrl: PropTypes.string,
  helpCentreUrl: PropTypes.string,
  showArticleView: PropTypes.func,
};

export default ArticleView;
